/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import {useMemo} from 'react'
import {useLocation} from 'react-router-dom'
import {buildUrlSet} from '@salesforce/retail-react-app/app/utils/url'
import {RELEVANCE_SORT_ID} from '../constants'

/*
 * Generate a memoized list of sort urls. Changing the sort resets the page.
 * The relevance option maps to a url without any `sort` param.
 */
export const useSortUrls = ({options = []}) => {
    const location = useLocation()

    return useMemo(() => {
        const cleanQuery = new URLSearchParams(location.search)
        cleanQuery.delete('page')
        cleanQuery.delete('offset')
        cleanQuery.delete('sort')

        const baseUrl = `${location.pathname}?${cleanQuery.toString()}`

        // An empty value makes buildUrlSet drop the `sort` param.
        return buildUrlSet(
            baseUrl,
            'sort',
            options.map(({id}) => (id === RELEVANCE_SORT_ID ? '' : id))
        )
    }, [location.pathname, location.search, options])
}
